import React, { useRef, useEffect } from 'react';

const BeforeAfterInfoGraphics = ({
    title,
    problemCode,
    category,
    subCategory,
    concern,
    problemStatement,
    why1,
    why2,
    why3,
    why4,
    why5,
    rootCause,
    solution,
    fontSize,
    lineHeight,
    maxWidth,

    startXTitle,
    startYTitle,
    startXProblemCode,
    startYProblemCode,
    startXCategory,
    startYCategory,
    startXSubCategory,
    startYSubCategory,

    startXConcern,
    startYConcern,
    startXProblemStatement,
    startYProblemStatement,
    startXWhy1,
    startYWhy1,
    startXWhy2,
    startYWhy2,
    startXWhy3,
    startYWhy3,
    startXWhy4,
    startYWhy4,
    startXWhy5,
    startYWhy5,
    startXRootCause,
    startYRootCause,
    startXSolution,
    startYSolution,

    problemKey,
    why1Key,
    why2Key,
    why3Key,
    why4Key,
    why5Key,
    rootCauseKey,
    solutionKey,
    startXProblemKey,
    startYProblemKey,
    startXWhy1Key, 
    startYWhy1Key, 
    startXWhy2Key, 
    startYWhy2Key, 
    startXWhy3Key, 
    startYWhy3Key, 
    startXWhy4Key, 
    startYWhy4Key,
    startXWhy5Key, 
    startYWhy5Key, 
    startXRootCauseKey, 
    startYRootCauseKey, 
    startXSolutionKey,
    startYSolutionKey,

    problemMea,
    why1Mea,
    why2Mea,
    why3Mea,
    why4Mea,
    why5Mea,
    rootCauseMea,
    solutionMea,
    startXProblemMea, 
    startYProblemMea, 
    startXWhy1Mea, 
    startYWhy1Mea, 
    startXWhy2Mea,
    startYWhy2Mea, 
    startXWhy3Mea, 
    startYWhy3Mea, 
    startXWhy4Mea, 
    startYWhy4Mea,
    startXWhy5Mea,
    startYWhy5Mea, 
    startXRootCauseMea, 
    startYRootCauseMea, 
    startXSolutionMea, 
    startYSolutionMea, 

    problemOut,
    why1Out,
    why2Out,
    why3Out,
    why4Out,
    why5Out,
    rootCauseOut,
    solutionOut,
    startXProblemOut, 
    startYProblemOut, 
    startXWhy1Out,
    startYWhy1Out, 
    startXWhy2Out, 
    startYWhy2Out, 
    startXWhy3Out, 
    startYWhy3Out, 
    startXWhy4Out, 
    startYWhy4Out,
    startXWhy5Out, 
    startYWhy5Out, 
    startXRootCauseOut, 
    startYRootCauseOut, 
    startXSolutionOut, 
    startYSolutionOut, 

    imageSrc,
    viewWidth,
}) => {
    const canvasRef = useRef(null);

    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        // console.log(text);
        var words = text.split(' ');
        var line = '';
        for (var i = 0; i < words.length; i++) {
            var testLine = line + words[i] + ' ';
            var metrics = ctx.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > maxWidth && i > 0) {
                ctx.fillText(line, x, y);
                line = words[i] + ' ';
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        maxWidth = viewWidth; //viewWidth;

        // Draw the image
        const image = new Image();
        image.onload = function () {
            canvas.width = image.width;
            canvas.height = image.height;

            ctx.drawImage(image, 0, 0);

            // Draw the elements
            ctx.font = `${fontSize}px Arial`;
            wrapText(ctx, problemCode, startXProblemCode, startYProblemCode, maxWidth, lineHeight);
            
            wrapText(ctx, problemStatement, startXProblemStatement, startYProblemStatement, 400, lineHeight);
            wrapText(ctx, problemKey, startXProblemKey, startYProblemKey, 180, lineHeight);
            wrapText(ctx, problemOut, startXProblemOut, startYProblemOut, 180, lineHeight);
            
            wrapText(ctx, why1, startXWhy1, startYWhy1, 210, lineHeight);
            wrapText(ctx, why1Key, startXWhy1Key, startYWhy1Key, 150, lineHeight);
            wrapText(ctx, why1Mea, startXWhy1Mea, startYWhy1Mea, 150, lineHeight);
            wrapText(ctx, why1Out, startXWhy1Out, startYWhy1Out, 180, lineHeight);

            wrapText(ctx, why2, startXWhy2, startYWhy2, 210, lineHeight);
            wrapText(ctx, why2Key, startXWhy2Key, startYWhy2Key, 150, lineHeight);
            wrapText(ctx, why2Mea, startXWhy2Mea, startYWhy2Mea, 150, lineHeight);
            wrapText(ctx, why2Out, startXWhy2Out, startYWhy2Out, 180, lineHeight);
            
            wrapText(ctx, why3, startXWhy3, startYWhy3, 210, lineHeight);
            wrapText(ctx, why3Key, startXWhy3Key, startYWhy3Key, 150, lineHeight);
            wrapText(ctx, why3Mea, startXWhy3Mea, startYWhy3Mea, 150, lineHeight);
            wrapText(ctx, why3Out, startXWhy3Out, startYWhy3Out, 180, lineHeight);
            
            wrapText(ctx, why4, startXWhy4, startYWhy4, 210, lineHeight);
            wrapText(ctx, why4Key, startXWhy4Key, startYWhy4Key, 150, lineHeight);
            wrapText(ctx, why4Mea, startXWhy4Mea, startYWhy4Mea, 150, lineHeight);
            wrapText(ctx, why4Out, startXWhy4Out, startYWhy4Out, 180, lineHeight);            
            
            wrapText(ctx, why5, startXWhy5, startYWhy5, 210, lineHeight);
            wrapText(ctx, why5Key, startXWhy5Key, startYWhy5Key, 150, lineHeight);
            wrapText(ctx, why5Mea, startXWhy5Mea, startYWhy5Mea, 150, lineHeight);
            wrapText(ctx, why5Out, startXWhy5Out, startYWhy5Out, 180, lineHeight);     
            
            wrapText(ctx, rootCause, startXRootCause, startYRootCause, 210, lineHeight);
            wrapText(ctx, rootCauseKey, startXRootCauseKey, startYRootCauseKey, 150, lineHeight);
            wrapText(ctx, rootCauseMea, startXRootCauseMea, startYRootCauseMea, 150, lineHeight);
            wrapText(ctx, rootCauseOut, startXRootCauseOut, startYRootCauseOut, 180, lineHeight);
            
            wrapText(ctx, solution, startXSolution, startYSolution, 400, lineHeight);
            // wrapText(ctx, solutionKey, startXSolutionKey, startYSolutionKey, 180, lineHeight);
            // wrapText(ctx, solutionMea, startXSolutionMea, startYSolutionMea, 160, lineHeight);
            wrapText(ctx, solutionOut, startXSolutionOut, startYSolutionOut, 180, lineHeight);
        };
        image.src = imageSrc;
    }, [
        title,
        problemCode,
        category,
        subCategory,
        concern,
        problemStatement,
        why1,
        why2,
        why3,
        why4,
        why5,
        rootCause,
        solution,
        fontSize,
        lineHeight,
        maxWidth,

        startXTitle,
        startYTitle,
        startXProblemCode,
        startYProblemCode,
        startXCategory,
        startYCategory,
        startXSubCategory,
        startYSubCategory,

        startXConcern,
        startYConcern,
        startXProblemStatement,
        startYProblemStatement,
        startXWhy1,
        startYWhy1,
        startXWhy2,
        startYWhy2,
        startXWhy3,
        startYWhy3,
        startXWhy4,
        startYWhy4,
        startXWhy5,
        startYWhy5,
        startXRootCause,
        startYRootCause,
        startXSolution,
        startYSolution,

        problemKey,
        why1Key,
        why2Key,
        why3Key,
        why4Key,
        why5Key,
        rootCauseKey,
        solutionKey,
        startXProblemKey,
        startYProblemKey,
        startXWhy1Key, 
        startYWhy1Key, 
        startXWhy2Key, 
        startYWhy2Key, 
        startXWhy3Key, 
        startYWhy3Key, 
        startXWhy4Key, 
        startYWhy4Key,
        startXWhy5Key, 
        startYWhy5Key, 
        startXRootCauseKey, 
        startYRootCauseKey, 

        problemMea,
        why1Mea,
        why2Mea,
        why3Mea,
        why4Mea,
        why5Mea,
        rootCauseMea,
        solutionMea,
        startXProblemMea, 
        startYProblemMea, 
        startXWhy1Mea, 
        startYWhy1Mea, 
        startXWhy2Mea,
        startYWhy2Mea, 
        startXWhy3Mea, 
        startYWhy3Mea, 
        startXWhy4Mea, 
        startYWhy4Mea,
        startXWhy5Mea,
        startYWhy5Mea, 
        startXRootCauseMea, 
        startYRootCauseMea, 
        startXSolutionMea, 
        startYSolutionMea, 

        problemOut,
        why1Out,
        why2Out,
        why3Out,
        why4Out,
        why5Out,
        rootCauseOut,
        solutionOut,
        startXProblemOut, 
        startYProblemOut, 
        startXWhy1Out,
        startYWhy1Out, 
        startXWhy2Out, 
        startYWhy2Out, 
        startXWhy3Out, 
        startYWhy3Out, 
        startXWhy4Out, 
        startYWhy4Out,
        startXWhy5Out, 
        startYWhy5Out, 
        startXRootCauseOut, 
        startYRootCauseOut, 
        startXSolutionOut, 
        startYSolutionOut, 

        imageSrc,
        viewWidth,
    ]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                maxWidth: '100%',
            }}
        ></canvas>
    );
};

export default BeforeAfterInfoGraphics;
